import React, { useState } from 'react';
import { Table, TableBody, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Input } from '@/components/ui/input';

import { Search } from 'lucide-react';
import { CsvImportDialog } from './CsvImportDialog';
import { useImportedUsers } from './imported-users/hooks/useImportedUsers';
import { useImportProcessing } from './imported-users/hooks/useImportProcessing';
import { useImportedUsersSearch } from './imported-users/hooks/useImportedUsersSearch';
import { ImportedUserTableRow } from './imported-users/ImportedUserTableRow';
import { ImportedUsersEmptyState } from './imported-users/ImportedUsersEmptyState';
import { ImportedUsersErrorState } from './imported-users/ImportedUsersErrorState';

export const ImportedUsersManagement = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const { data: importRecords, isLoading, error, refetch } = useImportedUsers();
  const { processImportMutation, processingRecords } = useImportProcessing();
  const filteredRecords = useImportedUsersSearch(importRecords, searchTerm);

  if (isLoading) {
    return <div>Loading import records...</div>;
  }

  if (error) {
    console.error('Import records error:', error);
    return <ImportedUsersErrorState error={error} onRetry={refetch} />;
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between gap-4">
        <div className="relative flex-1 max-w-md">
          <Search className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder="Search by name, email, or status..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="pl-10"
          />
        </div>
        <div className="flex gap-4 items-center">
          <CsvImportDialog />
        </div>
      </div>

      {filteredRecords && filteredRecords.length > 0 ? (
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Name</TableHead>
              <TableHead>Email</TableHead>
              <TableHead>Role</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Import Date</TableHead>
              <TableHead>Last Invitation</TableHead>
              <TableHead>Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {filteredRecords.map((record) => {
              const isProcessing = processingRecords.has(record.id);
              
              return (
                <ImportedUserTableRow
                  key={record.id}
                  record={record}
                  isProcessing={isProcessing}
                  onProcess={processImportMutation.mutate}
                />
              );
            })}
          </TableBody>
        </Table>
      ) : (
        <ImportedUsersEmptyState searchTerm={searchTerm} />
      )}
    </div>
  );
};